export default __webpack_public_path__ + "static/media/banner-bg.bd62c0d7.svg";